import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { createContext } from 'react';
import {
  makeApiProvider,
  useApiQuery,
} from '@pflegenavi/shared-frontend/platform';
import type { IResidentPhoenixApi } from './api';
import { ResidentPhoenixApi } from './api';
import type {
  ResidentControllerQueryTypes,
  ResidentControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';

const ApiContext = createContext<IResidentPhoenixApi | undefined>(undefined);
const {
  useApi: useResidentPhoenixApi,
  ApiProvider: ResidentPhoenixApiProvider,
} = makeApiProvider({
  name: 'ResidentPhoenix',
  ApiContext,
  newApi: (tenantId, auth, apiUrl) =>
    new ResidentPhoenixApi(tenantId, auth, apiUrl),
});

export {
  useResidentPhoenixApi,
  ResidentPhoenixApiProvider,
  ApiContext as ResidentPhoenixApiContext,
};
export type { IResidentPhoenixApi } from './api';

const GET_RESIDENT_LIST_PHOENIX_KEY = (params: {
  nursingHomeId: string;
  globalServiceProviderId: string;
}) => ['getResidentListPhoenix', params];

export const useGetResidentListPhoenix = (
  params: ResidentControllerQueryTypes['getResidentList'],
  options: Omit<
    UseQueryOptions<ResidentControllerResultTypes['getResidentList'], unknown>,
    'queryFn' | 'queryKey'
  >
): UseQueryResult<
  ResidentControllerResultTypes['getResidentList'],
  unknown
> => {
  return useApiQuery(
    useResidentPhoenixApi,
    GET_RESIDENT_LIST_PHOENIX_KEY(params),
    (api) => api.getResidentList({ params }),
    options
  );
};
